import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";
import routes from "../../utils/routes";
import { Linkedin, Instagram } from "../../assets/images/icons/Social";
import { LINKEDIN_PROFILE, INSTAGRAM_PROFILE } from "../../utils/constants";
import logo from '../../assets/images/full_logo.svg';

function Footer() {
  return (
    <footer className="footer-container">
      <div className="footer-top">
        <div>
          <img src={logo} alt="Brand logo" className="footer-logo" />
        </div>
        <div className="footer-links">
          <Link className="footer-link" to={routes.home}>Inicio</Link>
          <Link className="footer-link" to={routes.products}>Productos</Link>
          <Link className="footer-link" to={routes.about}>Nosotros</Link>
        </div>
        <div className="footer-social">
          {/* <a href={LINKEDIN_PROFILE}><Linkedin /></a> */}
          <a href={INSTAGRAM_PROFILE}><Instagram /></a>
        </div>
      </div>
      <div>Tu socio estratégico en gastronomía.</div>
    </footer>
  )
}

export default Footer;